import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useQuery, useMutation } from '@apollo/client';

import { captureException } from '@playbookux/playbook-web-core';
import { GET_SIMILARITY_MATRIX, PROCESS_SIMILARITY_MATRIX } from '../../graphql';

import {
  Container,
  Image,
  Loader,
  Title,
  Subtitle,
} from './styles';

const POLL_INTERVAL = 3000;

const Dendrogram = (props) => {
  const {
    project: {
      id,
    },
    segmentId,
  } = props;

  const {
    data: { cardSortAnalytics } = {},
    stopPolling,
  } = useQuery(GET_SIMILARITY_MATRIX, {
    variables: {
      projectId: id,
      segmentId,
    },
    pollInterval: POLL_INTERVAL,
  });

  const [processSimilarityMatrix] = useMutation(PROCESS_SIMILARITY_MATRIX);

  const {
    dendrogramImage,
  } = cardSortAnalytics || {};

  const [imageUrl, setImageUrl] = useState('');

  useEffect(() => {
    if (dendrogramImage) {
      setImageUrl(dendrogramImage);
      stopPolling();
    } else {
      try {
        processSimilarityMatrix({
          variables: {
            projectId: id,
          },
        });
      } catch (ex) {
        captureException('DENDROGRAM_USE_EFFECT_FAILED', ex);
      }
    }
  }, [dendrogramImage,
    id,
    setImageUrl,
    stopPolling,
    processSimilarityMatrix,
  ]);

  if (!imageUrl) {
    return (
      <Container>
        <Loader data-loader="dendrogram-loader" />
      </Container>
    );
  }

  return (
    <Container>
      <Title>Best Merge Method</Title>
      <Subtitle>
        This method helps you extract as much information as possible from small data sets (less than 30 participants)
      </Subtitle>
      <Image src={imageUrl} />
    </Container>
  );
};

Dendrogram.propTypes = {
  project: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  segmentId: PropTypes.string,
};

Dendrogram.defaultProps = {
  segmentId: undefined,
};

export default Dendrogram;
